@switch (app.client.sizeId < 2)
  {
  <!--
  Mobile
  -->
    @case (true) {
    <filter-expandable>
        <!-- options list -->
        <span class="s1"
              expandableTitle>{{'Sort' | translate}}</span>
        <div expandableBody
             class="m-t-5 flex-column">
            @for (option of sort.getOptions(); track option) {
            <button type="button"
                    class="s1 p-a-1 left p-r-2 p-l-2 b-col-1"
                    (click)="sortBy(option)"
                    [class]="(sort.selectionLabel === option.label ? 'bg-col-6':'bg-col-w b-a') + $last ? '' : 'm-b-2'"
                    style="border-radius: 12px; width: fit-content;">{{option.label | translate}}</button>
            }
        </div>
    </filter-expandable>
    }
    <!-- Default -->
    @default {
    <listing-dropdown class="inline-block b-a b-col-1 p-a-2"
                      style="border-radius: 12px;"
                      (valueChange)="sort.by($event)"
                      [options]="sort.getOptions()">
        <ng-template #titleTpl>{{'Sort' | translate}}</ng-template>
        <ng-template #optionTpl
                     let-option>
            <div class="s1 p-a-1 left p-r-2 p-l-2 b-col-1 "
                 [class]="sort.selectionLabel === option.label ? 'bg-col-6':'bg-col-w b-a'"
                 style="border-radius: 12px;">{{option.label | translate}}</div>
        </ng-template>
    </listing-dropdown>
    }
    }